import { extendTheme } from '@chakra-ui/react';

export const chakraTheme = extendTheme({
  colors: {
    blue: {
      500: '#007bff',
    },
    pink: {
      500: '#f14c78',
      600: '#f05471',
    },
    orange: {
      500: '#ef4123',
      700: '#963501',
    },
    yellow: {
      500: '#fdc03b',
    },
    teal: {
      500: '#48bfb6',
    },
  },
});
